import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AuthHeader from '../components/AuthHeader'

const TermsOfUsePage = () => {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-black">
      <div className='p-4'>
        <div className="border-2 border-white">
          <AuthHeader />
          <div className='bg-[#141414] p-4 w-full min-h-screen'>
            <div className="w-full max-w-4xl mx-auto py-8 px-4">
              <div className="bg-card border border-gray-700 p-6 md:p-8">
                {/* Back Button */}
                <button
                  onClick={() => navigate(-1)}
                  className="mb-6 flex items-center gap-2 text-gray-400 hover:text-white transition-colors font-avenir text-sm"
                >
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                  </svg>
                  Back
                </button>

                <h1 className="text-3xl md:text-4xl font-bold text-white mb-2 font-avenir tracking-wider">
                  Terms of Use
                </h1>
                <p className="text-gray-400 text-sm mb-8 font-avenir">
                  TLP Network Inc. (The Launch Pad)
                </p>
                <p className="text-gray-400 text-sm mb-8 font-avenir">
                  Effective Date: January 2026
                </p>

                <div className="prose prose-invert max-w-none text-white space-y-6 font-avenir">
                  <p className="text-gray-300 leading-relaxed">
                    These Terms of Use ("Terms") govern your use of the websites, platforms, content, and services operated by TLP Network Inc. ("TLP," "The Launch Pad," "we," "us," or "our").
                  </p>
                  <p className="text-gray-300 leading-relaxed">
                    By accessing or using our Services, you agree to these Terms.
                  </p>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">1. Use of Our Services</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">You agree to use the Services lawfully and respectfully. You may not:</p>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Violate laws or regulations</li>
                      <li>Infringe intellectual property rights</li>
                      <li>Disrupt or interfere with our Services</li>
                      <li>Harass, abuse, or harm others</li>
                      <li>Attempt unauthorized access to systems or data</li>
                    </ul>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">2. Intellectual Property</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">
                      All content—including videos, livestreams, graphics, logos, text, and branding—is owned by or licensed to TLP unless otherwise stated.
                    </p>
                    <p className="text-gray-300 leading-relaxed">
                      You may not reproduce or distribute content without prior written permission, except where explicitly allowed.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">3. User Content</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">If you submit content, you:</p>
                    <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                      <li>Retain ownership of your content</li>
                      <li>Grant TLP a worldwide, royalty-free license to use and display it in connection with our Services</li>
                      <li>Confirm you have the right to submit the content</li>
                    </ul>
                    <p className="text-gray-300 leading-relaxed mt-3">
                      We reserve the right to remove content at our discretion.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">4. Third-Party Links & Services</h2>
                    <p className="text-gray-300 leading-relaxed">
                      Our Services may link to third-party platforms. TLP is not responsible for their content or practices.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">5. Donations, Purchases & Subscriptions</h2>
                    <p className="text-gray-300 leading-relaxed">
                      Payments are processed by third-party providers. Unless otherwise stated, all sales and donations are final.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">6. Disclaimers</h2>
                    <p className="text-gray-300 leading-relaxed mb-3">
                      The Services are provided "as is" and "as available."
                    </p>
                    <p className="text-gray-300 leading-relaxed mb-3">
                      We make no guarantees regarding accuracy, availability, or outcomes.
                    </p>
                    <p className="text-gray-300 leading-relaxed">
                      Spaceflight and launch information may change rapidly and should not be considered official or authoritative.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">7. Limitation of Liability</h2>
                    <p className="text-gray-300 leading-relaxed">
                      To the fullest extent permitted by law, TLP is not liable for indirect or consequential damages arising from use of the Services.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">8. Indemnification</h2>
                    <p className="text-gray-300 leading-relaxed">
                      You agree to indemnify and hold harmless TLP and its affiliates from claims arising from your use of the Services or violation of these Terms.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">9. Termination</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We may suspend or terminate access to the Services at any time for violations of these Terms.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">10. Governing Law</h2>
                    <p className="text-gray-300 leading-relaxed">
                      These Terms are governed by the laws of Canada.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">11. Changes to These Terms</h2>
                    <p className="text-gray-300 leading-relaxed">
                      We may update these Terms at any time. Continued use constitutes acceptance of the revised Terms.
                    </p>
                  </section>

                  <section className="mt-8">
                    <h2 className="text-2xl font-bold text-white mb-4 font-avenir tracking-wide">12. Contact Us</h2>
                    <p className="text-gray-300 leading-relaxed mb-2">TLP Network Inc.</p>
                    <p className="text-gray-300 leading-relaxed">
                      Email: <a href="mailto:contact@tlpnetwork.com" className="text-red-400 hover:text-red-300 transition-colors">contact@tlpnetwork.com</a>
                    </p>
                  </section>
                </div>

                {/* Footer Links */}
                <div className="mt-12 pt-6 border-t border-gray-700 flex flex-wrap justify-center gap-4 text-sm">
                  <Link
                    to="/privacy-policy"
                    className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
                  >
                    Privacy Policy
                  </Link>
                  <span className="text-gray-600">|</span>
                  <Link
                    to="/login"
                    className="text-gray-400 hover:text-red-300 transition-colors font-avenir"
                  >
                    Back to Login
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TermsOfUsePage
